module.exports = __webpack_public_path__ + "media/img/home/clients-map/together-6d6773e508b3f4b2dbd197fbb47fc672.svg";